export default __webpack_public_path__ + "static/login-bg-2024e648acf07d90db91baa439547ab5.png";